<script lang="ts">
	import { DotLottieSvelte } from '@lottiefiles/dotlottie-svelte';
	import { Text } from '@Shelly/shelly-design-system';

	export let src: string = 'https://assets2.lottiefiles.com/packages/lf20_wxUJzo.json';
	export let autoplay: boolean = true;
	export let loop: boolean = true;
	export let controls: boolean = false;
	export let height: number = 500;
	export let width: number = 500;
	export let background: string = 'transparent';

	/**
	 * When `true`, the wrapper fills its parent (no unused empty space) and
	 * `width`/`height` are treated as upper bounds. The lottie animation keeps
	 * its intrinsic aspect ratio thanks to lottie-web's `preserveAspectRatio`
	 * setting. Defaults to `false` to preserve the fixed-pixel behavior used by
	 * the Radar onboarding steps.
	 */
	export let fillContainer: boolean = false;

	export let showPreviewLabel: boolean = true;
	export let previewLabelText: string = 'Preview';
	export let previewLabelPosition: 'top-left' | 'top-right' = 'top-right';

	$: containerStyle = fillContainer ? `max-width: ${width}px; max-height: ${height}px;` : '';
	$: innerStyle = fillContainer
		? 'width:100%;height:100%;'
		: `width: ${width}px; height: ${height}px;`;
</script>

<div class="lottie-player-container" class:fill-container={fillContainer} style={containerStyle}>
	{#if showPreviewLabel}
		<div class="preview-label preview-label-{previewLabelPosition}">
			<Text styleType="body-small" class="text-color-muted">{previewLabelText}</Text>
		</div>
	{/if}
	<div style={innerStyle}>
		<DotLottieSvelte {src} {autoplay} {loop} backgroundColor={background} />
	</div>
</div>

<style>
	.lottie-player-container {
		position: relative;
		display: inline-block;
	}

	.lottie-player-container.fill-container {
		display: flex;
		width: 100%;
		height: 100%;
		align-items: center;
		justify-content: center;
	}

	.lottie-player-container.fill-container > :global(div) {
		width: 100%;
		height: 100%;
	}

	.lottie-player-container.fill-container :global(.lottie-player) {
		width: 100%;
		height: 100%;
	}

	.lottie-player-container.fill-container :global(.animation) {
		width: 100%;
		height: 100%;
		display: flex;
	}

	.lottie-player-container.fill-container :global(.animation svg) {
		width: 100% !important;
		height: 100% !important;
	}

	.preview-label {
		position: absolute;
		background: rgba(231, 21, 21, 0.9);
		padding: 4px 8px;
		border-radius: 4px;
		z-index: 10;
		box-shadow: 0 1px 3px rgba(250, 250, 250, 0.1);
	}

	.preview-label-top-right {
		top: 8px;
		right: 8px;
	}

	.preview-label-top-left {
		top: 8px;
		left: 8px;
	}
</style>
